import { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";

// Fecha fija de lanzamiento (cuenta regresiva de 30 días). Editable.
export const LAUNCH_DATE = new Date("2026-07-22T12:00:00-06:00");

const pad = (n) => String(n).padStart(2, "0");

function getRemaining(target) {
  const diff = Math.max(0, target.getTime() - Date.now());
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { days, hours, minutes, seconds, done: diff === 0 };
}

const Unit = ({ value, label, testid, delay }) => (
  <motion.div
    data-testid={testid}
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    className="group relative flex flex-col items-center justify-center border border-white/[0.08] bg-white/[0.015] px-3 py-5 backdrop-blur-xl transition-colors duration-500 hover:border-[#00F0FF]/30 sm:px-6 sm:py-8"
  >
    <span
      className="font-mono text-4xl font-medium tabular-nums tracking-tight text-white sm:text-6xl md:text-7xl"
      style={{ textShadow: "0 0 24px rgba(0,240,255,0.18)" }}
    >
      {pad(value)}
    </span>
    <span className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[#00F0FF]/70 sm:text-xs">
      {label}
    </span>
    <span className="absolute left-0 top-0 h-2 w-2 border-l border-t border-[#00F0FF]/0 transition-colors duration-500 group-hover:border-[#00F0FF]/60" />
    <span className="absolute bottom-0 right-0 h-2 w-2 border-b border-r border-[#00F0FF]/0 transition-colors duration-500 group-hover:border-[#00F0FF]/60" />
  </motion.div>
);

export const Countdown = () => {
  const [t, setT] = useState(() => getRemaining(LAUNCH_DATE));

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining(LAUNCH_DATE)), 1000);
    return () => clearInterval(id);
  }, []);

  const units = useMemo(
    () => [
      { value: t.days, label: "Días", testid: "countdown-days" },
      { value: t.hours, label: "Horas", testid: "countdown-hours" },
      { value: t.minutes, label: "Minutos", testid: "countdown-minutes" },
      { value: t.seconds, label: "Segundos", testid: "countdown-seconds" },
    ],
    [t]
  );

  return (
    <div data-testid="countdown" className="w-full">
      <div className="grid grid-cols-4 gap-2 sm:gap-4">
        {units.map((u, i) => (
          <Unit key={u.label} {...u} delay={0.1 * i} />
        ))}
      </div>
    </div>
  );
};

export default Countdown;
